$(function() {
	$('#languageSelection').change(function e() {
		var lang = $(this).val();
		if (lang) {
			$.cookie('siteLocale', lang, {
				expires : 365,
				path : '/'
			});

		}
		reloadPage();
	});

	$('#currencySelection').change(function e() {
		var currency = $(this).val();
		if (currency) {
			$.cookie('currency', currency, {
				expires : 365,
				path : '/'
			});
			
			try {
				var curr = $('input[type=hidden][name=reload_currency]');
				if(curr != null && curr.length > 0)
					$('input[type=hidden][name=reload_currency]').val(currency);
				else{
					var postForm = $("#postForm");
					$('<input>').attr({
						type: 'hidden',
					    name: 'reload_currency',
					    value: currency
					}).appendTo(postForm);
				}

			} catch (e) {
				// TODO: handle exception
			}
		}
		reloadPage();
	});

	var currency = $.cookie('currency');
	if (currency) {
		$("#currencySelection").val(currency);
	}

	var siteLocale = $.cookie('siteLocale');
	if (siteLocale) {
		$('#languageSelection').val(siteLocale);
    }

	$(".loading-link").click(function() {
		$('#loading').modal('show');
	});
	
	//Scroll top top
	var mybutton = document.getElementById("btn-back-to-top");
	
	if (mybutton != null) {
		// When the user scrolls down 20px from the top of the document, show the button
		window.onscroll = function () {
		  scrollFunction();
		};
		
		function scrollFunction() {
		  if (
		    document.body.scrollTop > 500 ||
		    document.documentElement.scrollTop > 500
		  ) {
		    mybutton.style.display = "block";
		  } else {
		    mybutton.style.display = "none";
		  }
		}
		// When the user clicks on the button, scroll to the top of the document
		mybutton.addEventListener("click", backToTop);
		
		function backToTop() {
		  document.body.scrollTop = 0;
		  document.documentElement.scrollTop = 0;
		}
	}
});

function reloadPage() {
	window.location.reload();
}
